/**
 * EdgeStream React Context
 */

import React from 'react';
import type { IEdgeStream } from '../types';

export interface EdgeStreamContextValue {
  stream: IEdgeStream;
}

export const EdgeStreamContext = React.createContext<EdgeStreamContextValue | null>(null);
